import ProductCard from "./ProductCard";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function FeaturedSection({ title, kicker, products, linkTo = "/produtos", testId }) {
  if (!products || !products.length) return null;
  return (
    <section className="m20-container py-10 bg-[#faf9f6]" data-testid={testId}>
      <div className="flex items-end justify-between mb-6 gap-4">
        <div>
          {kicker && (
            <div className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-primary mb-1">{kicker}</div>
          )}
          <h2 className="font-display font-bold uppercase text-2xl sm:text-3xl lg:text-4xl text-foreground">{title}</h2>
        </div>
        <Link to={linkTo} className="text-sm font-semibold text-primary hover:underline inline-flex items-center gap-1">
          Ver tudo <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 sm:gap-5">
        {products.slice(0, 10).map(p => <ProductCard key={p.id} product={p} />)}
      </div>
    </section>
  );
}
